// src/utils/KeycloakProviderWrapper.tsx
import React, { ReactNode } from "react";
import { Provider } from "react-redux";
import globalStore from "../../store/CreateStore";
import useKeycloakInit from "./useKeycloakInit";
import { AuthContext } from "../AuthContent";

const KeycloakProviderWrapper = ({ children }: { children: ReactNode }) => {
  const { authenticated, keycloak } = useKeycloakInit();

  if (!authenticated) {
    return <></>;
  }

  return (
    <AuthContext.Provider value={{ authenticated, keycloak }}>
      <Provider store={globalStore}>
        {children}
      </Provider>
    </AuthContext.Provider>
  );
};

export default KeycloakProviderWrapper;